import { mealActionTypes } from '../actions/mealActions.js';
import { SERVICE_TYPE } from '../../../constant.js';
import { groupByKey } from '~/utils/object';

const initState = {
  meals: {
    [SERVICE_TYPE.DELIVERY]: {},
    [SERVICE_TYPE.PICKUP]: {},
    [SERVICE_TYPE.SHUTTLE]: {},
    [SERVICE_TYPE.DINE_IN]: {},
  },
  mealInventory: {},
  mealCustomizations: {},
  mealCustomizationOptions: {},
  mealCustomizationInventory: {},
};

const handleLoadMealsSuccess = (state, action) => {
  const { serviceType } = action;
  const meals = {
    ...state.meals,
    ...{
      [serviceType]: {
        ...state.meals[serviceType],
        ...groupByKey(action.meals, (meal) => meal.id, true),
      },
    },
  };
  return {
    ...state,
    ...{
      meals,
    },
  };
};

const handleLoadMealInventroies = (state, action) => {
  return {
    ...state,
    ...{
      mealInventory: {
        ...state.mealInventory,
        ...action.inventroies,
      },
    },
  };
};

const handleLoadMealCustomizations = (state, action) => {
  return {
    ...state,
    ...{
      mealCustomizations: {
        ...state.mealCustomizations,
        ...action.customizations,
      },
    },
  };
};

const handleLoadMealCustomizationInventories = (state, action) => {
  return {
    ...state,
    ...{
      mealCustomizationInventory: {
        ...state.mealCustomizationInventory,
        ...action.inventroies,
      },
    },
  };
};

const handleLoadMealCustomizationOptions = (state, action) => {
  return {
    ...state,
    ...{
      mealCustomizationOptions: {
        ...state.mealCustomizationOptions,
        ...action.options,
      },
    },
  };
};

const MealsReducer = (state = initState, action) => {
  switch (action.type) {
    case mealActionTypes.loadMealsByMealIdsSuccess:
      return handleLoadMealsSuccess(state, action);

    case mealActionTypes.loadMealsByRestaurantsSuccess:
      return handleLoadMealsSuccess(state, action);

    case mealActionTypes.loadMealInventorySuccess:
      return handleLoadMealInventroies(state, action);

    case mealActionTypes.loadMealCustomizationsSuccess:
      return handleLoadMealCustomizations(state, action);

    case mealActionTypes.loadMealCustomizationOptionsSuccess:
      return handleLoadMealCustomizationOptions(state, action);

    case mealActionTypes.loadMealCustomizationInventorySuccess:
      return handleLoadMealCustomizationInventories(state, action);

    case mealActionTypes.fetchMissingMealsStart:
      return state;

    case mealActionTypes.fetchMissingMealsSuccess:
      return handleLoadMealsSuccess(state, action);


    default:
      return state;
  }
};

export default MealsReducer;
